const routes = [

  {
    path: '/mockups',
    name: 'mockups',
    meta: { layout: 'bpc-mockups' },
    component: () => import(/* webpackChunkName: "mockups" */ '@/mockups/pages/index.vue'),
    children: [
      {
        path: '',
        name: 'mockups-web-home',
        meta: { layout: 'bpc-mockups' },
        component: () => import(/* webpackChunkName: "mockups-web-home" */ '@/mockups/pages/web/home.vue'),
      },
      {
        path: 'profile',
        name: 'mockups-profile',
        meta: { layout: 'bpc-mockups' },
        component: () => import(/* webpackChunkName: "mockups-profile" */ '@/mockups/pages/profile.vue'),
      },
      {
        path: 'admin',
        name: 'mockups-admin',
        meta: { layout: 'bpc-mockups', withSidebar: true },
        component: () => import(/* webpackChunkName: "mockups-admin" */ '@/mockups/pages/admin/index.vue'),
        children: [
          // Testing route
          {
            path: '',
            name: 'mockups-admin-dashboard',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-dashboard" */ '@/mockups/pages/admin/dashboard.vue'),
          },
          {
            path: 'contacts',
            name: 'mockups-admin-contacts',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-contacts" */ '@/mockups/pages/admin/contacts.vue'),
          },
          {
            path: 'contacts/2',
            name: 'mockups-admin-contact',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-contacts" */ '@/mockups/pages/admin/contact2.vue'),
          },
          {
            path: 'contacts/:contact_id',
            name: 'mockups-admin-contact',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-contacts" */ '@/mockups/pages/admin/contact.vue'),
          },
          {
            path: 'subscriptions',
            name: 'mockups-admin-subscriptions',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-subscriptions" */ '@/mockups/pages/admin/subscriptions.vue'),
          },
          {
            path: 'documents',
            name: 'mockups-admin-documents',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-documents" */ '@/mockups/pages/admin/documents.vue'),
          },
          {
            path: 'calendars',
            name: 'mockups-admin-calendars',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-calendars" */ '@/mockups/pages/admin/calendars.vue'),
          },
          {
            path: 'bookings',
            name: 'mockups-admin-bookings',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-bookings" */ '@/mockups/pages/admin/bookings.vue'),
          },
          {
            path: 'resources',
            name: 'mockups-admin-resources',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-resources" */ '@/mockups/pages/admin/resources.vue'),
          },
          {
            path: 'activities',
            name: 'mockups-admin-activities',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-activities" */ '@/mockups/pages/admin/activities.vue'),
          },
          {
            path: 'registrations',
            name: 'mockups-admin-registrations',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-registrations" */ '@/mockups/pages/admin/registrations.vue'),
          },
          {
            path: 'products',
            name: 'mockups-admin-products',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-products" */ '@/mockups/pages/admin/products.vue'),
          },
          {
            path: 'orders',
            name: 'mockups-admin-orders',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-orders" */ '@/mockups/pages/admin/orders.vue'),
          },
          {
            path: 'invoices',
            name: 'mockups-admin-invoices',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-invoices" */ '@/mockups/pages/admin/invoices.vue'),
          },
          {
            path: 'accounts',
            name: 'mockups-admin-accounts',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-accounts" */ '@/mockups/pages/admin/accounts.vue'),
          },
          {
            path: 'statistics',
            name: 'mockups-admin-statistics',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-statistics" */ '@themes/architectui/src/DemoPages/Charts/ApexCharts.vue'),
          },
          {
            path: 'reporting',
            name: 'mockups-admin-reporting',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-reporting" */ '@/mockups/pages/admin/reporting.vue'),
          },
          {
            path: 'logs',
            name: 'mockups-admin-logs',
            meta: { layout: 'bpc-mockups', withSidebar: true },
            component: () => import(/* webpackChunkName: "mockups-admin-logs" */ '@/mockups/pages/admin/logs.vue'),
          },
        ],
      },
    ],
  },
];

export default routes;
